import { atom } from 'jotai';
import { match } from 'ts-pattern';
import { CALENDAR_WEEK_STARTS_ON, CALENDAR_WEEK_STARTS_ON_KEY } from '@studio/constants/calendar';

const _getStoredWeekStartsOn = (): CALENDAR_WEEK_STARTS_ON => {
  try {
    return match(localStorage.getItem(CALENDAR_WEEK_STARTS_ON_KEY))
      .with(String(CALENDAR_WEEK_STARTS_ON.MON), () => CALENDAR_WEEK_STARTS_ON.MON)
      .otherwise(() => CALENDAR_WEEK_STARTS_ON.SUN);
  } catch (error) {
    console.error('Failed to get stored calendar week start preference', error);
    return CALENDAR_WEEK_STARTS_ON.SUN;
  }
};

export const weekStartsOnAtom = atom<CALENDAR_WEEK_STARTS_ON>(_getStoredWeekStartsOn());

export const setWeekStartsOnAtom = atom(null, (_get, set, weekStartsOn: CALENDAR_WEEK_STARTS_ON) => {
  set(weekStartsOnAtom, weekStartsOn);

  try {
    localStorage.setItem(CALENDAR_WEEK_STARTS_ON_KEY, String(weekStartsOn));
  } catch (error) {
    console.error('Failed to save calendar week start preference', error);
  }
});
